import * as React from 'react';
export var IconX = React.forwardRef(function IconX({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M11.78 5.28a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M17.78 7.28a.75.75 0 0 0-1.06-1.06L12 10.94 7.28 6.22a.75.75 0 0 0-1.06 1.06L10.94 12l-4.72 4.72a.75.75 0 1 0 1.06 1.06L12 13.06l4.72 4.72a.75.75 0 1 0 1.06-1.06L13.06 12l4.72-4.72Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M17.78 7.28a.75.75 0 0 0-1.06-1.06L12 10.94 7.28 6.22a.75.75 0 0 0-1.06 1.06L10.94 12l-4.72 4.72a.75.75 0 1 0 1.06 1.06L12 13.06l4.72 4.72a.75.75 0 1 0 1.06-1.06L13.06 12l4.72-4.72Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
